module.exports = __webpack_public_path__ + "media/site_templates/www.floor-sanding.net.au/images/testimonials-a064e9de90edc54c314ac0f569617cdc.jpg";